import { render, staticRenderFns } from "./SynchronizationAssesmentOld.vue?vue&type=template&id=826e8686&"
import script from "./SynchronizationAssesmentOld.vue?vue&type=script&lang=js&"
export * from "./SynchronizationAssesmentOld.vue?vue&type=script&lang=js&"
import style0 from "./SynchronizationAssesmentOld.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports